import React from 'react';
import './CustomAreaBarStyle.css';

const CustomAreaBar = ({width, bgColor} : {width: number, bgColor: string}) => {

    return (
        <div className="area-bar">
            <span className="area-tick" style={{left:"50%"}}></span>
            <span className="area-tick" style={{left:"60%"}}></span>
            <span className="area-tick" style={{left:"70%"}}></span>
            <span className="area-tick" style={{left:"80%"}}></span>
            <span className="area-tick" style={{left:"90%"}}></span>
            <div className="area-bar-fill" style={{width: `${width}%`, backgroundColor: bgColor}}></div>
        </div>
    );
};

export default CustomAreaBar;